import Router from 'vue-router';
import routes from '@/views/routes';
import { installRouterPlugins, scrollBehavior } from '@/lib/vue';

const router = new Router({
  mode: 'history',
  scrollBehavior,
  routes,
});

installRouterPlugins(router);

export default router;
